import Token from 'vindi-ds-tokens';

const buttonRoot = {
  marginTop: '16px',
  minWidth: '208px',
};

export default {
  complete: {
    backgroundColor: '#DBFFE1',
    boxShadow: 'none',
    color: Token.color.functional.light['200'].value,
  },
  incomplete: {
    backgroundColor: '#F5F7FA',
    boxShadow: 'none',
  },
  buttonStyle: {
    ...buttonRoot,
  },
  cardLinks: {
    color: Token.color.brand.secondary[500].value,
    display: 'inline',
  },
};
